import { render, staticRenderFns } from "./single-surgery-annotation.vue?vue&type=template&id=15c66a34&scoped=true"
import script from "./single-surgery-annotation.vue?vue&type=script&lang=ts"
export * from "./single-surgery-annotation.vue?vue&type=script&lang=ts"
import style0 from "./single-surgery-annotation.vue?vue&type=style&index=0&id=15c66a34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c66a34",
  null
  
)

export default component.exports